// frozen_string_literal: true
// Detects YouTube or Vimeo URLs (or bare IDs) and returns the correct embed src.

export function videoEmbedUrl(url: string): string {
  // YouTube: full URL with watch?v= or youtu.be/ shortlink
  const ytMatch = url.match(/(?:youtube\.com\/watch\?.*v=|youtu\.be\/)([A-Za-z0-9_-]{11})/)
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`

  // YouTube: bare 11-character video ID (alphanumeric, underscore, hyphen)
  if (/^[A-Za-z0-9_-]{11}$/.test(url)) return `https://www.youtube.com/embed/${url}`

  // Vimeo: full URL (vimeo.com/ID or vimeo.com/video/ID)
  const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)
  if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`

  return url
}
